<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
    <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称">
            <a-input :disabled="params.isShow" placeholder="请输入货运部名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入货运部名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input :disabled="params.isShow" placeholder="请输入联系电话" v-decorator="[
          'telephone',
          {initialValue:data.telephone,rules: [{ required: true, message: '请输入联系电话' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>      
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="默认货运部">
            <a-radio-group name="isDefault" v-decorator="[
          'isDefault',
          {initialValue:data.isDefault,rules: [{ required: false, message: '默认货运部' }]}]">
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  name: "",
  telephone: "",
  isDefault: false
};
export default {
  name: "hp-manager-page-dealerFreight-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  components: {},
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      dealerId: null
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getDealerFreight();
    } else {
      this.data = exzends(defaultData);
    }
    this.dealerId = this.params.dealerId;
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getDealerFreight() {
      this.loading = true;
      let result = await api.GetDealerFreight({ id: this.params.id });
      if (result) {
        this.data = result;
        this.data.name=this.data.name+"";
        this.data.telephone=this.data.telephone+"";
        this.data.isDefault=this.data.isDefault==1?true:false;
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        telephone: value.telephone,
        name: value.name,        
        isDefault: value.isDefault,
        dealerId: this.params.dealerId
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.AddOrUpdateDealerFreight(requestData);
        if (this.params.id > 0) {
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Dealer/AddDealerFreight.vue